// Single source of truth for the catalogue of /servicios/:slug pages.
// Used by ServicioPage routing AND by the SSG build to pre-render every
// service page as static HTML.
export const SERVICE_SLUGS = [
  "publicidad-meta",
  "publicidad-tiktok",
  "redes-sociales",
  "google-ads",
  "chatgpt-ads",
  "seo",
  "seo-local",
  "consultoria",
  "web-corporativa",
  "tienda-online",
  "crm-implementacion",
  "branding",
  "landing-page",
  "email-marketing",
  "automatizacion",
  "mantenimiento-web",
  "incubadora",
] as const;

export type ServiceSlug = (typeof SERVICE_SLUGS)[number];
